import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Form, Table } from "react-bootstrap";
import { servicePath } from "../../../../../utility/data";
import PricingHeader from "../../../../../components/Pricing/PricingHeader";
import axios from "axios";
import { useEffect } from "react";
import {
  handleEmptyValues,
  handleFocus,
  newHandleInput,
} from "../../../../../utility/helper";
import { useRightContext } from "../../../../../context/rightMenuContext";
import PricingTableComp from "../../../../../components/PricingTableComp";

const Left = ({
  token,
  setMessage,
  setMessageType,
  loading,
  setLoading,
  collectionId,
  pageName,
}) => {
  const navlinks = [
    {
      id: 1,
      name: "Lump sum",
    },
    {
      id: 2,
      name: "Square metre",
    },
    {
      id: 3,
      name: "Minimum area",
    },
  ];
  const [selectedPricing, setSelectedPricing] = useState();
  const [selectedSupplyOnly, setSelectedSupplyOnly] = useState("");
  const [costPrice, setCostPrice] = useState([]);
  const [activeTab, setActiveTab] = useState("Lump sum");
  const [lumpSumData, setLumpSumData] = useState([]);
  const [squareMetreData, setSquareMetreData] = useState([]);
  const { userDataContext, setUserDataContext } = useRightContext("");
  const navigate = useNavigate();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    setLoading(true);
    if (selectedPricing && collectionId && selectedSupplyOnly) {
      getFrameStylePricing(collectionId);
    }
  }, [selectedPricing, collectionId, selectedSupplyOnly]);

  const getFrameStylePricing = (collectionID) => {
    const FormData = require("form-data");

    let data = new FormData();

    data.append("PriceMasterId", selectedPricing);
    data.append("MarkupMasterId", selectedSupplyOnly);
    data.append("FrameStyleCollectionId", collectionID);
    data.append("TypeId", 1);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${servicePath}/General/GetFrameStylePricingList`,
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };

    axios
      .request(config)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setLoading(false);
          setLumpSumData(res?.data?.entity["lumpsum"]);
          setSquareMetreData(res?.data?.entity["squareMetre"]);
        } else if (res?.data?.statusCode === 404) {
          setLoading(false);
          navigate("/error/404");
        } else {
          setLoading(false);
          setMessage(
            res?.data?.message ? res.data.message : "Something went wrong"
          );
          setMessageType("error");
        }
      })
      .catch((error) => {
        console.log(error);

        setLoading(false);
        setMessage(error.message ? error.message : "Something went wrong");
        setMessageType("error");

        if (error?.message === "Network Error") {
          navigate("/error/network");
        }
      });
  };

  

  const handleInput = (setMethod, id, key, value) => {
    if (validate(value)) {
      setMethod((prevData) =>
        prevData.map((item, index) =>
          index === id ? { ...item, [key]: parseFloat(value) } : item
        )
      );
    }
  };

  const validate = (value) => {
    if (value < 0) return false;
    return true;
  };

  const handleUpdate = () => {
    setLoading(true);
    updateFrameStylePricing();
  };

  const updateFrameStylePricing = () => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${servicePath}/General/AddUpdateFrameStylePricing`,
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: handleEmptyValues([...lumpSumData, ...squareMetreData]),
    };

    axios
      .request(config)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setMessage(res.data.message);
          setMessageType("success");
          getFrameStylePricing(collectionId);
        }
      })
      .catch((error) => {
        console.log(error);

        setLoading(false);
        setMessage(error.message ? error.message : "Something went wrong");
        setMessageType("error");

        if (error?.message === "Network Error") {
          navigate("/error/network");
        }
      });
  };

  const handleFormReset = () => {
    setLoading(true);
    getFrameStylePricing(collectionId);
  };

  // const data1 = { url: `/product/systems/style-collections/collection/${collectionId}` }
  // const data1 = { url: `/product/systems/styles/list`, stateValue: collectionId }

  return (
    <>
      <PricingHeader
        setSelectedSupplyOnly={setSelectedSupplyOnly}
        setSelectedPricing={setSelectedPricing}
        selectedPricing={selectedPricing}
        selectedSupplyOnly={selectedSupplyOnly}
        costPrice={costPrice}
      />

      <Nav tabs className="details_header border-0 nav-tabs-custom">
        {navlinks.map((item) => (
          <NavItem key={item.id}>
            <NavLink
              className={`${activeTab === item.name ? "active" : "text-muted"}`}
              onClick={() => handleTabChange(item.name)}
            >
              {item.name}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab} className="flex-grow-1 d-flex">
        <TabPane tabId="Lump sum" className="flex-grow-1 w-100">
          <Form className="h-100 d-flex flex-column flex-grow-1 justify-content-between">
            <div className="inside_scroll has_tab has_btns">
              <PricingTableComp
                data={lumpSumData}
                handleInput={handleInput}
                newHandleInput={newHandleInput}
                setData={setLumpSumData}
                userDataContext={userDataContext}
              ></PricingTableComp>
            </div>
            <div className="d-flex gap-2 gap-xl-3 main_buttons">
              <Button
                color="primary"
                size="md"
                className="px-4"
                onClick={handleUpdate}
              >
                Save Changes
              </Button>

              <Button
                color="primary"
                size="md"
                outline
                className="px-4"
                onClick={handleFormReset}
              >
                Reset
              </Button>
            </div>
          </Form>
        </TabPane>
        <TabPane tabId="Square metre" className="flex-grow-1 w-100">
          <Form className="h-100 d-flex flex-column flex-grow-1 justify-content-between">
            <div className="inside_scroll has_tab has_btns">
              <PricingTableComp
                data={squareMetreData}
                handleInput={handleInput}
                newHandleInput={newHandleInput}
                setData={setSquareMetreData}
                userDataContext={userDataContext}
              ></PricingTableComp>
            </div>
            <div className="d-flex gap-2 gap-xl-3 main_buttons">
              <Button
                color="primary"
                size="md"
                className="px-4"
                onClick={handleUpdate}
              >
                Save Changes
              </Button>

              <Button
                color="primary"
                size="md"
                outline
                className="px-4"
                onClick={handleFormReset}
              >
                Reset
              </Button>
            </div>
          </Form>
        </TabPane>
        <TabPane tabId="Minimum area" className="flex-grow-1 w-100">
          <Form className="h-100 d-flex flex-column flex-grow-1 justify-content-between">
            <div className="inside_scroll has_tab has_btns">
              <Table responsive className="w-100 discount_table">
                <thead className="border-bottom">
                  <tr className="text-end">
                    <th style={{ width: "90%", minWidth: "90%" }}></th>
                    <th>
                      m<sup>2</sup>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {lumpSumData && lumpSumData.length > 0 ? (
                    <>
                      {lumpSumData &&
                        lumpSumData.map((item, index) => (
                          <tr key={index}>
                            <td>{item.frameStyleName}</td>
                            <td>
                              <Form.Control
                                onFocus={handleFocus}
                                type="number"
                                value={item.mSquar}
                                onChange={(e) =>
                                  handleInput(
                                    setLumpSumData,
                                    index,
                                    "mSquar",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={7}>
                        <h5 className="my-4 text-center text-muted w-100">
                          No data found
                        </h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex gap-2 gap-xl-3 main_buttons">
              <Button
                color="primary"
                size="md"
                className="px-4"
                onClick={handleUpdate}
              >
                Save Changes
              </Button>

              <Button
                color="primary"
                size="md"
                outline
                className="px-4"
                onClick={handleFormReset}
              >
                Reset
              </Button>
            </div>
          </Form>
        </TabPane>
      </TabContent>
    </>
  );
};

export default Left;
